import sidebar from './sidebar';
import collect from './collect';
import { FETCH_START, FETCH_DONE } from './mutation-types';
const GET_WHITE_LIST = 'GET_WHITE_LIST';
const UPDATE_BACK_PAGE = 'UPDATE_BACK_PAGE';
const UPDATE_FEEDBACK_PAGE = 'UPDATE_FEEDBACK_PAGE';
const UPDATE_WARNNING_PAGE = 'UPDATE_WARNNING_PAGE';
const UPDATE_ROUTE_NAMES = 'UPDATE_ROUTE_NAMES';
const UPDATE_RECHARGE_PAGE = 'UPDATE_RECHARGE_PAGE';

let fetchCount = 0;
const state = () => ({
  loading: false,
  whiteList: [],
  dashboardBackPage: undefined,
  feedbackPage: undefined,
  warnningPage: undefined,
  rechargePage: undefined,
  routeNames: [],
});

const getters = {
  loading: state => state.loading,
  whiteList: state => state.whiteList,
  dashboardBackPage: state => state.dashboardBackPage,
  feedbackPage: state => state.feedbackPage,
  warnningPage: state => state.warnningPage,
  routeNames: state => state.routeNames,
  rechargePage: state => state.rechargePage,
};

const actions = {
  fetchStart({ commit }, notLoading) {
    commit(FETCH_START, notLoading);
  },
  fetchDone({ commit }, notLoading) {
    commit(FETCH_DONE, notLoading);
  },
  getWhiteList({ commit }, list) {
    commit(GET_WHITE_LIST, list);
  },
  updateBackPage({ commit }, name) {
    commit(UPDATE_BACK_PAGE, name);
  },
  updateFeedbackPage({ commit }, name) {
    commit(UPDATE_FEEDBACK_PAGE, name);
  },
  updateWarnningPage({ commit }, name) {
    commit(UPDATE_WARNNING_PAGE, name);
  },
  updateRouteNames({ commit }, name) {
    commit(UPDATE_ROUTE_NAMES, name);
  },
  updateRechargePage({ commit }, name) {
    commit(UPDATE_RECHARGE_PAGE, name);
  },
};
const mutations = {
  [FETCH_START](state, notLoading) {
    if (!notLoading) {
      fetchCount++;
      state.loading = true;
    }
  },
  [FETCH_DONE](state, notLoading) {
    if (!notLoading) {
      fetchCount--;
    }
    if (fetchCount === 0) {
      state.loading = false;
    }
  },
  [GET_WHITE_LIST](state, list) {
    state.whiteList = [...state.whiteList, ...list];
  },
  [UPDATE_BACK_PAGE](state, name) {
    state.dashboardBackPage = name;
  },
  [UPDATE_FEEDBACK_PAGE](state, name) {
    state.feedbackPage = name;
  },
  [UPDATE_WARNNING_PAGE](state, name) {
    state.warnningPage = name;
  },
  [UPDATE_RECHARGE_PAGE](state, name) {
    state.rechargePage = name;
  },
  [UPDATE_ROUTE_NAMES](state, name) {
    let idx = state.routeNames.indexOf(name);
    if (idx > -1) {
      state.routeNames = [
        ...state.routeNames.slice(0, idx),
        ...state.routeNames.slice(idx + 1),
      ];
    } else {
      state.routeNames.push(name);
    }
  },
  DEL_VISITED_VIEWS: (state, view) => {
    let name = view.name;
    let idx = state.routeNames.indexOf(name);
    if (idx > -1) {
      state.routeNames = [
        ...state.routeNames.slice(0, idx),
        ...state.routeNames.slice(idx + 1),
      ];
    }
  },
  DEL_OTHERS_VIEWS: (state, view) => {
    state.routeNames = [view.name];
  },
  DEL_ALL_VIEWS: state => {
    state.routeNames = [];
  },
};
export default {
  modules: {
    sidebar,
    collect,
  },
  state,
  getters,
  actions,
  mutations,
};
